/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Scanner_Filter_FailInputs */

const en_portal_scanner_filter_fail = /** @type {(inputs: Portal_Scanner_Filter_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title does not pass the filter`)
};

const de_portal_scanner_filter_fail = /** @type {(inputs: Portal_Scanner_Filter_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title does not pass the filter`)
};

const fr_portal_scanner_filter_fail = /** @type {(inputs: Portal_Scanner_Filter_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title does not pass the filter`)
};

const es_portal_scanner_filter_fail = /** @type {(inputs: Portal_Scanner_Filter_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title does not pass the filter`)
};

const it_portal_scanner_filter_fail = /** @type {(inputs: Portal_Scanner_Filter_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title does not pass the filter`)
};

const nl_portal_scanner_filter_fail = /** @type {(inputs: Portal_Scanner_Filter_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title does not pass the filter`)
};

const pl_portal_scanner_filter_fail = /** @type {(inputs: Portal_Scanner_Filter_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title does not pass the filter`)
};

const fi_portal_scanner_filter_fail = /** @type {(inputs: Portal_Scanner_Filter_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title does not pass the filter`)
};

const da_portal_scanner_filter_fail = /** @type {(inputs: Portal_Scanner_Filter_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title does not pass the filter`)
};

const sv_portal_scanner_filter_fail = /** @type {(inputs: Portal_Scanner_Filter_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title does not pass the filter`)
};

/**
* | output |
* | --- |
* | "Title does not pass the filter" |
*
* @param {Portal_Scanner_Filter_FailInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const portal_scanner_filter_fail = /** @type {((inputs?: Portal_Scanner_Filter_FailInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Scanner_Filter_FailInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_portal_scanner_filter_fail(inputs)
	if (locale === "fr") return fr_portal_scanner_filter_fail(inputs)
	if (locale === "es") return es_portal_scanner_filter_fail(inputs)
	if (locale === "it") return it_portal_scanner_filter_fail(inputs)
	if (locale === "nl") return nl_portal_scanner_filter_fail(inputs)
	if (locale === "pl") return pl_portal_scanner_filter_fail(inputs)
	if (locale === "fi") return fi_portal_scanner_filter_fail(inputs)
	if (locale === "da") return da_portal_scanner_filter_fail(inputs)
	if (locale === "sv") return sv_portal_scanner_filter_fail(inputs)
	return en_portal_scanner_filter_fail(inputs)
});